import { memo, useSyncExternalStore } from "react";
import { RowSelectionStore } from "../context/RowSelectionContext";
import { Badge } from "@/components/ui/badge";

interface RowSelectionCountBadgeProps {
  store: RowSelectionStore;
}

const RowSelectionCountBadgeComponent = ({
  store,
}: RowSelectionCountBadgeProps) => {
  const count = useSyncExternalStore(store.subscribe, store.getSelectionCount);

  if (count === 0) {
    return null;
  }

  return (
    <Badge variant="secondary" className="text-xs">
      {count}
    </Badge>
  );
};

export const RowSelectionCountBadge = memo(RowSelectionCountBadgeComponent);
